import { ClipLoader } from 'react-spinners'

const Loader = () => {
  return <div className='w-full flex justify-center py-2'>
    <ClipLoader color='#3b82f6' />
  </div>
}

export default Loader
